<!-- <p>report-post-dialog works!</p> -->
<div class="report-dialog-container">
  <h2 mat-dialog-title>Report Post</h2>

  <mat-dialog-content>
    <div class="post-preview">
      <p class="preview-label">You are reporting this post:</p>
      <div class="preview-content">
        <span class="post-author">{{ data.post.postUsername }}</span>
        <p class="post-text">
          {{ data.post.postDescription | slice : 0 : 100
          }}{{ data.post.postDescription.length > 100 ? "..." : "" }}
        </p>
      </div>
    </div>

    <form [formGroup]="reportForm" class="report-form">
      <mat-form-field
        appearance="outline"
        class="full-width"
        subscriptSizing="dynamic"
      >
        <mat-label>Reason for reporting</mat-label>
        <mat-select formControlName="reason" required>
          <mat-option
            *ngFor="let reason of reportReasons"
            [value]="reason.value"
          >
            {{ reason.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="reportForm.get('reason')?.hasError('required')">
          Please select a reason for reporting
        </mat-error>
      </mat-form-field>

      <mat-form-field
        *ngIf="showDescriptionField"
        appearance="outline"
        class="full-width"
      >
        <mat-label>Additional details</mat-label>
        <textarea
          matInput
          formControlName="description"
          placeholder="Please provide more details about your report"
          rows="3"
          maxlength="500"
        >
        </textarea>
        <mat-hint align="end"
          >{{ reportForm.get("description")?.value?.length || 0 }}/500</mat-hint
        >
        <mat-error *ngIf="reportForm.get('description')?.hasError('required')">
          Please provide additional details for this type of report
        </mat-error>
        <mat-error *ngIf="reportForm.get('description')?.hasError('minlength')">
          Please provide at least 10 characters
        </mat-error>
      </mat-form-field>

      <div class="warning-message">
        <mat-icon>warning</mat-icon>
        <p>
          False reports may result in restrictions on your account. Please only
          report content that violates community guidelines.
        </p>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="onSubmit()"
      [disabled]="!isFormValid || isSubmitting"
    >
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      <span *ngIf="!isSubmitting">Submit Report</span>
      <span *ngIf="isSubmitting">Submitting...</span>
    </button>
  </mat-dialog-actions>
</div>
